export enum TipoChavePix {
    EMPTY = '',
    CPF = 'CPF',
    CNPJ = 'CNPJ'
}